import { countries, getCountryCode, getEmojiFlag } from 'countries-list'

export interface NationalityDisplay {
	flag: string
	name: string
}

export const getNationalityDisplay = (
	country?: string | null,
	countryCode?: string | null,
): NationalityDisplay => {
	const normalizedCountry = country?.trim() || ''
	const normalizedCode = countryCode?.trim().toUpperCase() || ''
	const normalizedCountryKey = normalizedCountry
		.toLowerCase()
		.replace(/[^a-z0-9]/g, '')
	const codeFromName =
		normalizedCountryKey
			? (getCountryCode(normalizedCountry) ||
				(Object.entries(countries).find(
					([, item]) =>
						item.name.toLowerCase().replace(/[^a-z0-9]/g, '') ===
							normalizedCountryKey ||
						item.native.toLowerCase().replace(/[^a-z0-9]/g, '') ===
							normalizedCountryKey,
				)?.[0] as keyof typeof countries | undefined))
			: ''
	const resolvedCode = normalizedCode || codeFromName || ''
	const countryKey =
		resolvedCode && resolvedCode in countries
			? (resolvedCode as keyof typeof countries)
			: null
	const countryData = countryKey ? countries[countryKey] : null

	return {
		flag: countryKey ? getEmojiFlag(countryKey) : '',
		name: normalizedCountry || countryData?.name || '-',
	}
}

export const formatLastActive = (
	value?: string | number | null,
	now = Date.now(),
) => {
	if (value === null || value === undefined || value === '') return '-'

	const timestamp = Number(value)
	if (!Number.isFinite(timestamp) || timestamp <= 0) return '-'

	const differenceSeconds = Math.round((timestamp - now) / 1000)
	const absoluteSeconds = Math.abs(differenceSeconds)
	const relativeTime = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

	if (absoluteSeconds < 60) return 'just now'

	const differenceMinutes = Math.round(differenceSeconds / 60)
	if (Math.abs(differenceMinutes) < 60) {
		return relativeTime.format(differenceMinutes, 'minute')
	}

	const differenceHours = Math.round(differenceMinutes / 60)
	if (Math.abs(differenceHours) < 24) {
		return relativeTime.format(differenceHours, 'hour')
	}

	const differenceDays = Math.round(differenceHours / 24)
	return relativeTime.format(differenceDays, 'day')
}
